import React from 'react';
import styles from './index.module.less';
import $i18n from '@/i18n/index';

export default function TreeHeader() {
  return (
    <div className={styles.container}>
      <div className={styles.leftContainer}>
        {$i18n.get({
          id: 'aopf.pages.settings.document.setting.header.name',
          dm: '名称',
        })}
      </div>
      <div className={styles.rightContainer}>
        <div>
          {$i18n.get({
            id: 'aopf.pages.settings.document.setting.header.document',
            dm: '关联文档',
          })}
        </div>
        <div>
          {$i18n.get({
            id: 'aopf.pages.settings.document.setting.header.option',
            dm: '操作',
          })}
        </div>
      </div>
    </div>
  );
}
